export default {"src":"/_next/static/media/squiggly-decoration.10cf8b0c.svg","height":30,"width":213,"blurWidth":0,"blurHeight":0};